<p-dialog-container (closeEvent)="close()">
    <div class="p-Maintenance">
        <img [src]="imageSource" />
        <h2>{{'ScheduledMaintenancePopup.Title' | translate}}</h2>
        <p class="p-headline-5">{{'ScheduledMaintenancePopup.Msg1' | translate}}</p>
        <div class="p-maintenance-period p-headline-5 p-tpgr-medium">
            <div class="label">
                <span>{{'ScheduledMaintenancePopup.Start' | translate}}</span>
                <span>{{'ScheduledMaintenancePopup.End' | translate}}</span>
            </div>
            <div class="content">
                <div>
                    <span class="date-day">{{getStartDate('UTC')}}</span>
                    <span class="date-time">{{getStartDate('EST')}}</span>
                </div>
                <div>
                    <span class="date-day">{{getEndDate('UTC')}}</span>
                    <span class="date-time">{{getEndDate('EST')}}</span>
                </div>
            </div>
        </div>
        <p class="p-paragraph-2 p-tpgr-regular msg">{{'ScheduledMaintenancePopup.Msg2' | translate}}</p>
        <p-dialog-footer [btnConfig]="footerConfig">
            <p-checkbox [label]="'RecommendationsPopup.DontShowAgain' | translate" (checkedChange)="changeValue($event)"></p-checkbox>
        </p-dialog-footer>
    </div>
</p-dialog-container>
